import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import Slider from "@mui/material/Slider";

// Mapping the slider positions (0 to 6) to the backend float values
const backendValueMapping = [0, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8];
const displayValueMapping = [0, 3, 4, 5, 6, 7, 8]; // Integers to display on the UI

export default function NumberSlider(props) {
  // State to control the slider value
  const [sliderIndex, setSliderIndex] = useState(0);

  // Find the index of the closest value to the default (props.sliderNumber)
  useEffect(() => {
    const newIndex = backendValueMapping.indexOf(props.sliderNumber);
    if (newIndex >= 0) {
      setSliderIndex(newIndex);
    }
  }, [props.sliderNumber]);

  const handleSliderChange = (e, newValue) => {
    const mappedValue = backendValueMapping[newValue];
    setSliderIndex(newValue); // Update local state
    props.setSliderNumber(mappedValue); // Notify parent component
  };

  const valueLabelFormat = (index) => {
    return displayValueMapping[index];
  };

  return (
    <Box sx={{ width: 300 }}>
      <Slider
        value={sliderIndex} // Controlled by local state
        min={0}
        max={6}
        step={1}
        onChange={handleSliderChange}
        marks={[
          { value: 0, label: "" },
          { value: 1, label: "" },
          { value: 2, label: "" },
          { value: 3, label: "" },
          { value: 4, label: "" },
          { value: 5, label: "" },
          { value: 6, label: "" },
        ]}
        aria-label="Number Slider"
        valueLabelDisplay="auto"
        valueLabelFormat={valueLabelFormat}
        sx={{
          color: "#FB4764",
          "& .MuiSlider-thumb": {
            backgroundColor: "#fff1f2",
            "&:before": {
              backgroundColor: "#FB4764",
            },
          },
          "& .MuiSlider-track": {
            backgroundColor: "#FB4764",
          },
          "& .MuiSlider-rail": {
            backgroundColor: "#b39ddb",
          },
          "& .MuiSlider-valueLabel": {
            backgroundColor: "#fff1f2",
            color: "#FB4764",
            borderRadius: "4px",
          },
        }}
      />
    </Box>
  );
}
